import styled from 'styled-components';
import { CircleDiagramStyles } from './CircleDiagram.interface';

export const ItemWrapper = styled.div`
    height: 30px;
    font-size: 12px;
    line-height: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    >span {
        color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
        opacity: .87;
    }
`;

export const Color = styled.div<CircleDiagramStyles>`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
    margin-right: ${({ theme }) => theme.spacing * 3}px;
`;

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    >p {
        margin: 0;
        color: ${({ theme }) => theme.colors.blue};
        opacity: .87;
        font-weight: bold;
    }
`;

export const DoughnutWrapper = styled.div<CircleDiagramStyles>`
    display: flex;
    align-items: center;
    margin: ${({ theme }) => theme.spacing * 10}px 0 ${({ theme }) => theme.spacing * 8}px 0;
    justify-content: ${(props) => props.center ? 'flex-start' : 'center'}
`;
